import type { PaymentModuleId } from '@foundation/apis/payments';

import { InputRadioOption } from '@/components/common/forms/inputs/RadioGroup';

import { NewPaymentMethod } from './NewPaymentMethod';

export function computeRadioOptions(
  modules: ReadonlyArray<PaymentModuleId>,
): InputRadioOption[] {
  return modules.map((mid) => ({
    id: mid.toString(),
    label: <NewPaymentMethod moduleId={mid} />,
    value: mid.toString(),
    disabled: false,
  }));
}
